<template>
  <component
    :is="tag"
    class="t-typography"
    :style="styles"
  >
    <slot />
  </component>
</template>

<script>
export default {
  name: 'TTypography',
  props: {
    align: { type: String, default: '' },
    mb: { type: String, default: '' },
    mt: { type: String, default: '' },
    mr: { type: String, default: '' },
    ml: { type: String, default: '' },
    color: { type: String, default: 'bluegray' },
    light: { type: [String, Number], default: 80 },
    size: { type: String, default: 'sm' },
    weight: { type: [String, Number], default: 500 },
    tag: { type: String, default: 'div' },
    height: { type: String, default: 'near', validator: (value) => ['near', 'compact', 'far', 'further'].includes(value) },
  },
  computed: {
    fontSize() {
      const sizeAsNumber = parseFloat(this.size);
      if (Number.isNaN(sizeAsNumber)) {
        return `var(--track-font-size-${this.size})`;
      }
      return `${sizeAsNumber}px`;
    },
    styles() {
      return {
        color:
          this.color
          && this.light
          && `var(--track-color-${this.color}-${this.light})`,
        fontSize: this.fontSize,
        fontWeight: this.weight,
        marginBottom: this.mb && `var(--track-spacing-${this.mb})`,
        marginTop: this.mt && `var(--track-spacing-${this.mt})`,
        marginRight: this.mr && `var(--track-spacing-${this.mr})`,
        marginLeft: this.ml && `var(--track-spacing-${this.ml})`,
        textAlign: this.align,
        lineHeight: this.height && `var(--track-line-height-${this.height})`,
      };
    },
  },
};
</script>
